function ServiceLimitController(userService) {
    const ctrl = this;

    ctrl.logOut = () => {
        userService.logout();
    };
}

angular
    .module('service-limit.module')
    .controller('ServiceLimitController', ServiceLimitController);
